var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 17,
    viewBox: "0 0 51 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8382 16.1308H21.0285C21.0285 14.195 19.3888 12.6113 17.3847 12.6113V12.6125C15.3077 12.6078 13.2231 12.512 11.1578 12.3011C9.3986 12.1214 7.61614 11.8586 5.8989 11.444C4.25737 11.0476 0.542236 10.0315 0.542236 7.92002C0.542236 5.80851 4.25737 4.79247 5.8989 4.39609C7.61614 3.98142 9.3986 3.71867 11.1578 3.53898C13.2231 3.32804 15.3077 3.23223 17.3847 3.22754V4.01216C8.72199 4.08927 1.79732 5.80941 1.79732 7.92002C1.79732 10.0306 8.72199 11.7508 17.3847 11.8279V11.8291C19.3888 11.8291 21.0285 10.2454 21.0285 8.30963H21.8382C21.8382 10.2454 23.4779 11.8291 25.482 11.8291V12.6113C23.4779 12.6113 21.8382 14.195 21.8382 16.1308Z",
    fill: "#FFBA80",
    stroke: "#FFBA80",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1258 0.00204754H29.9355C29.9355 1.93778 31.5752 3.52156 33.5793 3.52156V3.52031C35.6562 3.525 37.7409 3.62081 39.8062 3.83174C41.5654 4.01143 43.3478 4.27418 45.0651 4.68886C46.7066 5.08524 50.4218 6.10128 50.4218 8.21279C50.4218 10.3243 46.7066 11.3403 45.0651 11.7367C43.3478 12.1514 41.5654 12.4141 39.8062 12.5938C37.7409 12.8048 35.6562 12.9006 33.5793 12.9053V12.1207C42.242 12.0435 49.1667 10.3234 49.1667 8.21279C49.1667 6.10218 42.242 4.38204 33.5793 4.30492V4.30367C31.5752 4.30367 29.9355 5.88745 29.9355 7.82318H29.1258C29.1258 5.88745 27.4861 4.30367 25.482 4.30367V3.52156C27.4861 3.52156 29.1258 1.93778 29.1258 0.00204754Z",
    fill: "#FFBA80",
    stroke: "#FFBA80",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateGold);
export default __webpack_public_path__ + "static/media/rotate-gold.3db254b1efb0a0d6c8278845561091f6.svg";
export { ForwardRef as ReactComponent };